export default __webpack_public_path__ + "static/media/runes.f91a7989.png";